import { css } from '@emotion/react';
import type { ReactElement, ReactNode } from 'react';

import { styled } from '../../../../styled';

type Interface = {
	className: string;
	children: ReactNode;
};

const style = css`
	width: 100%;

	& > * {
		max-width: 100%;
		white-space: pre-wrap;
	}
`;

const Component = ({ className, children }: Interface): ReactElement => <div className={className}>{children}</div>;

const MessageContent = styled(Component)(
	({ withLeftMargin }: { withLeftMargin?: boolean }) => ({
		marginLeft: withLeftMargin ? '45px' : 'auto',
	}),
	style
);

export { MessageContent };
